import React from 'react'

export const BottomLine = () => {
    return (
        <div style={{ width: 'calc(98 / var(--auto-width))', height: 'calc(3 / var(--auto-width))', background: 'linear-gradient(to right, #011053 0%, #309BFF 40%,#011053 100%)', margin: 'calc(24 / var(--auto-width)) auto 0' }}></div>
    )
}